import React from 'react';

// [background/text/border classes, dot colour] — the dot gives each status a
// crisp indicator instead of relying on the pill fill alone.
const CONFIG = {
  'Missing':                   ['bg-red-50 text-red-600 border-red-100',       '#ef4444'],
  'Missing Docs':              ['bg-red-50 text-red-600 border-red-200',       '#ef4444'],
  'Requested':                 ['bg-amber-50 text-amber-700 border-amber-100', '#f59e0b'],
  'Requested Additional Docs': ['bg-amber-50 text-amber-700 border-amber-200', '#f59e0b'],
  'Uploaded':                  ['bg-blue-50 text-blue-700 border-blue-100',    '#3b82f6'],
  'Under Review':              ['bg-purple-50 text-purple-700 border-purple-100', '#a855f7'],
  'Approved':                  ['bg-emerald-50 text-emerald-700 border-emerald-100', '#10b981'],
  'Rejected':                  ['bg-red-50 text-red-600 border-red-100',       '#ef4444'],
  'Needs Reupload':            ['bg-orange-50 text-orange-600 border-orange-100', '#f97316'],
  'Active':                    ['bg-emerald-50 text-emerald-700 border-emerald-100', '#10b981'],
  'Pending':                   ['bg-amber-50 text-amber-700 border-amber-100', '#f59e0b'],
  'Completed':                 ['bg-emerald-50 text-emerald-700 border-emerald-100', '#10b981'],
  'Complete':                  ['bg-emerald-50 text-emerald-700 border-emerald-200', '#10b981'],
  'Submitted to Admin Review': ['bg-cyan-50 text-cyan-700 border-cyan-200',    '#0891b2'],
  'Submitted for Approval':    ['bg-purple-50 text-purple-700 border-purple-200', '#a855f7'],
  'Submitted to Lender':       ['bg-blue-50 text-blue-700 border-blue-200',    '#3b82f6'],
  'Inactive':                  ['bg-slate-50 text-slate-500 border-slate-200', '#94a3b8'],
  // Current client-status set (Clients.jsx's STATUSES) - the entries above
  // this point are kept for other pages that reuse this same component for
  // document/request statuses (DocumentTable, Client Portal, etc.), not for
  // client status any more.
  'Waiting to be Shopped':     ['bg-indigo-50 text-indigo-700 border-indigo-200', '#6366f1'],
  'FTP':                       ['bg-violet-50 text-violet-700 border-violet-200', '#8b5cf6'],
  'Admin Review':              ['bg-cyan-50 text-cyan-700 border-cyan-200',    '#0891b2'],
  'Partial Submission':        ['bg-orange-50 text-orange-600 border-orange-200', '#f97316'],
  'Submitted to UW':           ['bg-blue-50 text-blue-700 border-blue-200',    '#3b82f6'],
  'Deal Decline':              ['bg-rose-50 text-rose-700 border-rose-200',    '#f43f5e'],
  'Deal Lost':                 ['bg-red-800 text-white border-red-900',        '#fecaca'],
  'Duplicate':                 ['bg-stone-100 text-stone-700 border-stone-300', '#78716c'],
  'Funded':                    ['bg-green-700 text-white border-green-800',    '#bbf7d0'],
};

const FALLBACK = ['bg-slate-50 text-slate-500 border-slate-200', '#94a3b8'];

export default function StatusBadge({ status, size = 'sm' }) {
  const [cls, dot] = CONFIG[status] || FALLBACK;
  const pad = size === 'xs' ? 'px-2 py-0.5 text-[10px] gap-1' : 'px-2.5 py-1 text-[11px] gap-1.5';
  return (
    <span className={`inline-flex items-center rounded-full font-semibold border whitespace-nowrap ${pad} ${cls}`}>
      <span className="rounded-full shrink-0" style={{ width: 5, height: 5, background: dot }} />
      {status}
    </span>
  );
}
